import { numberToWords, numberWithCommas } from "../../utils/utils";


export let billInfo = (billDetails) => {
    let UTCdate = new Date(billDetails?.billDate);
    return `<!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
    <head>
        <meta charset="utf-8" />
        <title></title>
    </head>
    <body>
        <table width="100%">
            <tr>
                <td colspan="4" height="50px"></td>
            </tr>
            <tr>
                <td colspan="4" align="center">
                    <h3>Money Receipt</h3>
                </td>
            </tr>
            <tr>
                <td width="10%" align="left">
                    <strong>Bill No:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.billNumber}</strong>
                </td>
                <td width="40%" align="left">
                    <strong>Bill Date:${UTCdate.toLocaleDateString()}</strong>
                </td>
            </tr>
            <tr>
                <td width="20%" align="left">
                    <strong>OPD Number:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.opdNumber !== undefined ? billDetails?.opdNumber : ""}</strong>
                </td>
                <td width="10%" align="left">
                    <strong>OPD Date:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.opdDate !== undefined ? billDetails?.opdDate : ""}</strong>
                </td>
            </tr>
            <tr>
                <td width="10%" align="left">
                    <strong>Name:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.patientName}</strong>
                </td>
                <td width="10%" align="left">
                    <strong>UHID No:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.emrNumber !== undefined ? billDetails?.emrNumber : ""}</strong>
                </td>
            </tr>
            <tr>
                <td width="10%" align="left">
                    <strong>Age/Sex:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.age}/${billDetails?.gender}</strong>
                </td>
                <td width="10%" align="left">
                    <strong>Doctor:</strong>
                </td>
                <td width="40%">
                    <strong>${billDetails?.doctor !== undefined ? billDetails?.doctor : ""}</strong>
                </td>
            </tr>
    
            <tr>
                <td colspan="4">
                    <hr />
                </td>
            </tr>
            <tr>
                <td colspan="4" align="center">
                    <table width="90%">
                        <tr>
                            <td width="10%" align="center">
                                <strong>Sl No</strong>
                            </td>
                            <td width="70%" align="center">
                                <strong>Particulars</strong>
                            </td>
                            <td width="10%" align="center">
                                <strong>Amount</strong>
                            </td>
                        </tr>
                    </table>
    
                </td>
            </tr>
            <tr>
                <td colspan="4">
                    <hr />
                </td>
            </tr>
            <tr>
                <td colspan="4" align="center">
                    <table width="90%">
                        <tr>
                            <td width="60%" align="right">
                                <strong>Gross Amount :</strong>
                            </td>
                            <td width="40%" align="left">
                                <strong>${billDetails?.billType}</strong>
                            </td>
    
                        </tr>
                        <tr>
                            <td width="60%" align="right">
                                <strong>Gross Amount :</strong>
                            </td>
                            <td width="40%" align="left">
                                <strong>${numberWithCommas(billDetails?.amount)}</strong>
                            </td>
    
                        </tr>
                        <tr>
                            <td width="60%" align="right">
                                <strong>Discount :</strong>
                            </td>
                            <td width="40%" align="left">
                                <strong>${billDetails?.discount !== undefined ? billDetails?.discount : 0}</strong>
                            </td>
    
                        </tr>
                        <tr>
                            <td width="60%" align="right">
                                <strong>Amount Paid :</strong>
                            </td>
                            <td width="40%" align="left">
                                <strong>${numberWithCommas(billDetails?.amount)}</strong>
                            </td>
    
                        </tr>
                        <tr>
                            <td width="60%" align="right">
                                <strong>Balance :</strong>
                            </td>
                            <td width="40%" align="left">
                                <strong>0</strong>
                            </td>
    
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td colspan="4">
                    Received with thanks a sum of  &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp; <strong>${numberToWords(billDetails?.amount)}</strong>
                </td>
            </tr>
        </table>
    </body>
    </html>
    `
}
